import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as contactActions from 'actions/contactActions';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';
import ContactsListTable from './ContactsListTable';
import { Label, Row, Col, Button, Card, CardBody, FormGroup } from 'reactstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';  // Import useNavigate from React Router

const ContactsList = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [contacts, setContacts] = useState([]);
  
  const areas = useSelector(state => state.referenceData.areas);
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    operationsApi.getContacts().then(result => {
      setContacts(result.data);
      setLoaded(true);
    });
  }, []);

  const searchContacts = searchString => {
    if (searchString.length >= 2) {
      operationsApi
        .getContactSearch(searchString)
        .then(result => result.data)
        .then(data => {
          setContacts(data);
          setLoaded(true);
        });
    }
  };

  const toggleNavigation = () => {
    setShowOverlay(prevState => !prevState);
  };

  const resetView = () => {
    operationsApi.getContacts().then(result => {
      setContacts(result.data);
      setLoaded(true);
    });
  };

  if (!loaded) return null;

  const options = {
    onRowClick: function(row) {
      navigate(`/contacts/edit/${row.id}`); // Use navigate for routing
    }
  };

  return (
    <div>
      <Header showLogo>
        <HeaderButtonNav>
          <HeaderButton
            color="primary"
            onClick={() => navigate('/contacts/create')} // Use navigate for routing
            ligature="add"
          />
        </HeaderButtonNav>
        <HeaderTitle label={'Contacts'} />
        <Card>
          <CardBody>
            <Row>
              <Col>
                <Select
                  name="Search Val"
                  placeholder="Enter Client name to searching"
                  onInputChange={searchContacts}
                />
              </Col>
              <Button onClick={resetView}>Reset</Button>
              <Col>
                <Label>&nbsp;</Label>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Header>
      <ContactsListTable
        options={options}
        contacts={contacts}
        areas={areas}
      />
    </div>
  );
};

export default ContactsList;
